<template>
  <div v-if="this.$store.get('systems@IPFS_USE') == 'Y'">
    <b-alert show class="text-left margin-bottom" variant="dark">
      <h5>IPD Order/Note Image : {{ this.changData() }}</h5>
      <div>
        <b-row>
          <b-col
            class="margin-bottom"
            cols="3"
            v-for="(item, index) in IpfsListDataOrder"
            v-bind:key="item.id"
          >
            <div>
              <b-modal
                :id="'modal-ipd-image-order' + index"
                title="IPD Order/Note Images"
                size="xl"
                hide-footer
              >
                <div class="text-align-center log-style">
                  File Name : {{ item.datas.ipfs_file_name }}
                </div>
                <div class="text-align-center log-style">
                  User log : {{ item.datas.ipfs_file_user }}
                </div>
                <div class="text-align-center log-style">
                  DateTime :
                  {{
                    thaiDatetimeFc.ThaiDateTime(item.datas.ipfs_file_datetime)
                  }}
                </div>
                <div class="text-align-center margin-bottom">
                  <b-img
                    rounded
                    class="image_physical_show"
                    :src="
                      'data:image;base64,' +
                        filterBase64(IpfsListDataOrderOk, item.id)
                    "
                    v-if="item"
                    :alt="
                      item.datas.ipfs_file_name +
                        '\nLog.' +
                        item.datas.ipfs_file_user +
                        ' | ' +
                        thaiDatetimeFc.ThaiDateTime(
                          item.datas.ipfs_file_datetime
                        )
                    "
                    :title="
                      item.datas.ipfs_file_name +
                        '\nLog.' +
                        item.datas.ipfs_file_user +
                        ' | ' +
                        thaiDatetimeFc.ThaiDateTime(
                          item.datas.ipfs_file_datetime
                        )
                    "
                  ></b-img>
                </div>

                <div class="d-block text-center">
                  <b-button
                    variant="info"
                    size="sm"
                    class="d-print-none"
                    v-print="'#modal-ipd-image-order' + index"
                  >
                    Print
                  </b-button>
                  &nbsp;
                  <b-button
                    size="sm"
                    class="d-print-none"
                    @click="$bvModal.hide('modal-ipd-image-order' + index)"
                    >Close</b-button
                  >
                  &nbsp;
                  <b-button
                    v-if="
                      item.ipfs_file_user ==
                        $store.get('systems@LoginData').UserId
                    "
                    variant="danger"
                    size="sm"
                    class="float-right d-print-none"
                    @click="IPFSIPDImageDel(item.datas.ipfs_file_hash)"
                    >Delete</b-button
                  >
                </div>
              </b-modal>
            </div>
            <div>
              <div>{{ getBase64file(item.id, item.datas, index) }}</div>
              <div class="text-align-center font12px">
                Time.
                {{ thaiDatetimeFc.ThaiDateTime(item.datas.ipfs_file_datetime) }}
              </div>
              <!-- 
              <div class="text-align-center font12px">
                Log. {{ item.ipfs_file_user }}
              </div>
              <div class="text-align-center font12px">
                Time.
                {{ thaiDatetimeFc.ThaiDateTime(item.datas.ipfs_file_datetime) }}
              </div> -->
              <b-img
                class="img-preview-ipfs cursor-pointer"
                center
                :src="
                  'data:image;base64,' +
                    filterBase64(IpfsListDataOrderOk, item.id)
                "
                :alt="
                  item.file_name +
                    '\nLog.' +
                    item.datas.ipfs_file_user +
                    ' | ' +
                    thaiDatetimeFc.ThaiDateTime(item.datas.ipfs_file_datetime)
                "
                :title="
                  item.file_name +
                    '\nLog.' +
                    item.datas.ipfs_file_user +
                    ' | ' +
                    thaiDatetimeFc.ThaiDateTime(item.datas.ipfs_file_datetime)
                "
                v-b-modal="'modal-ipd-image-order' + index"
              ></b-img>
            </div>
          </b-col>
        </b-row>
      </div>
      <div>
        <image-uploader
          id="emr-ipd-order-image"
          :debug="0"
          :quality="0.9"
          :autoRotate="true"
          :maxWidth="1024"
          :maxHeight="1024"
          outputFormat="file"
          :preview="false"
          :className="[
            'emr-ipd-order-image',
            { 'fileinput--loaded': hasImage }
          ]"
          :capture="false"
          accept="image/jpeg, image/png"
          doNotResize="['gif', 'svg']"
          @input="setImageIpdOrder"
          @onComplete="endImageResizeIpdOrder"
        >
          <label
            for="emr-ipd-order-image"
            slot="upload-label"
            style="width:100%;margin-bottom:0px;margin-top:4px;"
          >
            <figure style="margin-bottom: 0px">
              <v-icon
                name="camera"
                class="icon-camera-custom font-color-link2 cursor-pointer"
                style="color: yellow;"
              ></v-icon>
            </figure>
          </label>
        </image-uploader>
      </div>
    </b-alert>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import feather from "vue-icon";
import store from "@/store/store";
import thaiDatetime from "@/functions/thaiDatetime";
import pjFunctions from "@/functions/pjFunctions";
import PatientWebbaseUrl from "@/models/patientEMRs/PatientWebbaseUrl";
import PatientEmrIpfsOperativeNoteImage from "@/models/patientEMRs/PatientEmrIpfsOperativeNoteImage";

Vue.use(feather, "v-icon");

@Component({
  data() {
    return {
      thaiDatetimeFc: null,
      pjFunctionsFc: null,
      hasImage: false,
      IPDImageListData: [],
      IpfsListData: [],
      IpfsUrl: "",
      ptHN: "",
      ptAN: "",
      base64Check: [],
      IpfsListDataOrder: [],
      IpfsListDataOrderOk: [],
      base64cc: []
    };
  },
  props: ["MyHn", "MyAn"],
  component: {
    thaiDatetime,
    pjFunctions,
    PatientWebbaseUrl,
    PatientEmrIpfsOperativeNoteImage
  },
  created() {
    this.thaiDatetimeFc = thaiDatetime.methods;
    this.pjFunctionsFc = pjFunctions.methods;
  },
  watch: {
    ptAN: function() {
      this.setIpfsList(this.ptAN, this.ptHN);
    }
  },
  computed: {},
  mounted() {},
  methods: {
    show(group, type = "", title = "", text = "") {
      this.$notify({
        group,
        title: title,
        text: text,
        type,
        data: {
          randomNumber: Math.random()
        }
      });
    },
    clean(group) {
      this.$notify({ group, clean: true });
    },
    changData() {
      if (this.MyHn !== this.ptHN) {
        this.ptHN = this.MyHn;
      }
      if (this.MyAn !== this.ptAN) {
        this.ptAN = this.MyAn;
      }
    },
    setImageIpdOrder: function(output) {
      this.hasImage = true;
      this.image = output;
    },
    endImageResizeIpdOrder() {
      let Obj2 = this;
      let filesAddAtd = false;

      let formData = new FormData();

      formData.append("token_key", this.$store.get("systems@token_key"));
      formData.append("file_user", this.$store.get("systems@LoginData").UserId);

      formData.append("CompanyId", this.$store.get("systems@CompanyId"));
      formData.append("ApiKey", this.$store.get("systems@ApiKey"));
      formData.append("ipfs_action", "files-add-files");

      formData.append("key1", "emr-ipd-image");
      formData.append("key2", "order-image");
      formData.append("key3", "");
      formData.append("an", this.ptAN);
      formData.append("hn", this.ptHN);
      formData.append("files", this.image);

      this.axios
        .post(this.$store.get("systems@UrlApi") + "Call-IPFS-files", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(function(response) {
          Obj2.output = response.data;

          if (Obj2.output.status === true) {
            filesAddAtd = true;
          } else {
            filesAddAtd = false;
          }
        })
        .catch(function(error) {
          Obj2.output = error;
          console.log("files-add : " + Obj2.output);
        })
        .finally(function() {
          Obj2.ImageInsert(Obj2.output.result);
        });
    },

    ImageInsert(datas) {
      let SendData = datas[0];
      let ScrObj = this;
      this.axios
        .post(this.$store.get("systems@UrlApi") + "EmrIpdIpfsImageAdd", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
          hn: this.ptHN,
          an: this.ptAN,
          ipfs_file_hash: SendData.ipfs_file_hash,
          key1: SendData.key1,
          key2: SendData.key2,
          key3: SendData.key3,
          ipfs_token_key: SendData.ipfs_token_key,
          ipfs_file_name: SendData.ipfs_file_name,
          ipfs_file_type: SendData.ipfs_file_type,
          ipfs_file_extension: SendData.ipfs_file_extension
        })
        .then(function(response) {
          ScrObj.output = response.data;
          if (ScrObj.output.status === true) {
            // ddd
          } else {
            // console.log('EmrIpdIpfsImageAdd : '+ScrObj.output.ErrorMessage)
          }
        })
        .catch(function(error) {
          ScrObj.output = error;
          console.log("EmrIpdIpfsImageAdd : " + ScrObj.output);
        })
        .finally(function() {
          ScrObj.setIpfsList(ScrObj.ptAN, ScrObj.ptHN);
        });
    },

    IPFSIPDImageDel(hash) {
      this.conF = "";
      this.$bvModal
        .msgBoxConfirm("ยืนยันการลบรูปภาพ. !", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          this.conF = value;
          if (this.conF == true) {
            let ScrObj = this;
            this.axios
              .post(this.$store.get("systems@UrlApi") + "EmrIpdIpfsRemove", {
                CompanyId: this.$store.get("systems@CompanyId"),
                ApiKey: this.$store.get("systems@ApiKey"),
                ipfs_action: "files-remove",
                file_user: this.$store.get("systems@LoginData").UserId,
                hn: this.ptHN,
                an: this.ptAN,
                key1: "emr-ipd-image",
                key2: "order-image",
                key3: "",
                token_key: this.$store.get("systems@token_key"),
                hash: hash
              })
              .then(function(response) {
                ScrObj.output = response.data;
                if (ScrObj.output.status === true) {
                  // ddd
                } else {
                  // console.log('EmrIpdIpfsRemove : '+ScrObj.output.ErrorMessage)
                }
              })
              .catch(function(error) {
                ScrObj.output = error;
                console.log("EmrIpdIpfsRemove : " + ScrObj.output);
              })
              .finally(function() {
                ScrObj.setIpfsList(ScrObj.ptAN, ScrObj.ptHN);
              });
          }
        });
    },

    setIpfsList(an, hn) {
      let Obj6 = this;
      this.axios
        .post(this.$store.get("systems@UrlApi") + "EmrIpdIpfsImageGet", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
          hn: hn,
          an: an,
          key1: "emr-ipd-image",
          key2: "order-image",
          key3: ""
        })
        .then(function(response) {
          Obj6.output = response.data;
          if (Obj6.output.status === true) {
            PatientEmrIpfsOperativeNoteImage.delete({
              where(record) {
                return record.an == an && record.key2 == "order-image";
              }
            });

            let data = [];
            for (var val of Obj6.output.result) {
              data.push({
                id: val.ipfs_file_hash + val.ipfs_file_user,
                ipfs_file_user: val.ipfs_file_user,
                an: val.an,
                hn: val.hn,
                key1: val.key1,
                key2: val.key2,
                key3: val.key3,
                datas: val,
                list_orderby: val.list_orderby
              });
            }

            PatientEmrIpfsOperativeNoteImage.insertOrUpdate({
              data
            });
          } else {
            // console.log('EmrIpdIpfsImageGet : '+Obj5.output.ErrorMessage)
            if (Obj6.output.ErrorMessage === "Data Not Found") {
              PatientEmrIpfsOperativeNoteImage.delete({
                where(record) {
                  return record.an == an && record.key2 == "order-image";
                }
              });
            }
          }
        })
        .catch(function(error) {
          Obj6.output = error;
          console.log("EmrIpdIpfsImageGet : " + Obj6.output);
        })
        .finally(function() {
          Obj6.getIpfsList(Obj6.ptAN, Obj6.ptHN);
        });
    },

    getIpfsList(an, hn) {
      let IpfsUrlObj = PatientWebbaseUrl.query()
        .where(record => record.web_name == "IPFS-S1")
        .where(record => record.datas.web_status == "Y")
        .get();

      if (IpfsUrlObj.length > 0) {
        this.IpfsUrl = IpfsUrlObj[0].web_host;
      }

      let ScrObj = PatientEmrIpfsOperativeNoteImage.query()
        .where(record => record.datas.hn == hn)
        .where(record => record.datas.an == an)
        .where(record => record.key1 == "emr-ipd-image")
        .where(record => record.key2 == "order-image")
        .where(record => record.key3 == "")
        .orderBy("list_orderby", "desc")
        .get();

      if (ScrObj.length > 0) {
        this.IpfsListDataOrder = ScrObj;

        /*
        this.IpfsListData = [];
        let Obj2 = this;
        let datas = [];
        let n = 0;
        let result = null;
        let dd = null;
        let kk = 0;
        for (var val of ScrObj) {
          dd = {
            ipfs_file_user: val.datas.ipfs_file_user,
            ipfs_file_name: val.datas.ipfs_file_name,
            ipfs_file_datetime: val.datas.ipfs_file_datetime,
            an: val.datas.an,
            hn: val.datas.hn,
            key1: val.datas.key1,
            key2: val.datas.key2,
            key3: val.datas.key3,
            ipfs_file_hash: val.datas.ipfs_file_hash,
            datas: val.datas,
            list_orderby: val.datas.list_orderby
          };

          //this.IpfsListData.push(dd);

          this.axios
            .post(
              this.$store.get("systems@UrlApi") + "Call-IPFS-files-get-base64",
              {
                CompanyId: this.$store.get("systems@CompanyId"),
                ApiKey: this.$store.get("systems@ApiKey"),
                token_key: this.$store.get("systems@token_key"),
                hash: val.datas.ipfs_file_hash,
                datas: dd
              }
            )
            .then(function(response) {
              Obj2.output = response.data;
              if (Obj2.output.status === true) {
                Obj2.IpfsListData.push({
                  file_name: Obj2.output.result.file_name,
                  files_base64: Obj2.output.result.files_base64,
                  ipfs_file_user: Obj2.output.result.datas.ipfs_file_user,
                  an: Obj2.output.result.datas.an,
                  hn: Obj2.output.result.datas.hn,
                  key1: Obj2.output.result.datas.key1,
                  key2: Obj2.output.result.datas.key2,
                  key3: Obj2.output.result.datas.key3,
                  ipfs_file_hash: Obj2.output.result.datas.ipfs_file_hash,
                  datas: Obj2.output.result.datas,
                  list_orderby: Obj2.output.result.datas.list_orderby
                });
              }
            })
            .catch(function(error) {
              Obj2.output = error;
              console.log("files-get : " + Obj2.output);
            })
            .finally(function() {
              // console.log("ddd", Obj2.IpfsListData);
            });
        }

        */
      } else {
        this.IpfsListData = [];
      }
    },
    getBase64file(id, ar, num) {
      let arData = this.base64Check;

      let tm = num * 500;

      let value = arData.filter(item => {
        return item.id == id;
      });

      if (value.length <= 0) {
        this.base64Check.push({ id: id });

        setTimeout(() => {
          if (
            ar.ipfs_file_hash !== "" &&
            ar.ipfs_file_hash !== null &&
            ar.ipfs_file_hash !== undefined
          ) {
            let dd = {
              ipfs_file_user: ar.ipfs_file_user,
              ipfs_file_name: ar.ipfs_file_name,
              ipfs_file_datetime: ar.ipfs_file_datetime,
              an: ar.an,
              hn: ar.hn,
              key1: ar.key1,
              key2: ar.key2,
              key3: ar.key3,
              ipfs_file_hash: ar.ipfs_file_hash,
              datas: ar,
              list_orderby: ar.list_orderby
            };

            let Obj2 = this;

            this.axios
              .post(
                this.$store.get("systems@UrlApi") +
                  "Call-IPFS-files-get-base64",
                {
                  CompanyId: this.$store.get("systems@CompanyId"),
                  ApiKey: this.$store.get("systems@ApiKey"),
                  token_key: this.$store.get("systems@token_key"),
                  hash: ar.ipfs_file_hash,
                  datas: dd
                }
              )
              .then(function(response) {
                Obj2.output = response.data;
                if (Obj2.output.status === true) {
                  Obj2.IpfsListDataOrderOk.push({
                    id: id,
                    files_base64: Obj2.output.result.files_base64
                  });
                  // return Obj2.output.result.files_base64;
                }
              })
              .catch(function(error) {
                Obj2.output = error;
                console.log("files-get : " + Obj2.output);
              })
              .finally(function() {
                // console.log("ddd", Obj2.IpfsListData);
              });
          }
        }, tm);
      }
    },
    filterBase64(arr, id) {
      let arData = arr;

      let value2 = this.base64cc.filter(item => {
        return item.id == id;
      });

      if (value2.length <= 0) {
        let value = arData.filter(item => {
          return item.id == id;
        });

        if (value.length > 0) {
          if (value[0].files_base64 !== "") {
            this.base64cc.push({ id: id });
            return value[0].files_base64;
          } else {
            return null;
          }
        } else {
          return null;
        }
      } else {
        let value = arData.filter(item => {
          return item.id == id;
        });
        if (value.length > 0) {
          return value[0].files_base64;
        } else {
          return null;
        }
      }
    }
  }
})
export default class EmrAdmitOrderImage extends Vue {}
</script>

<style>
.emr-ipd-order-image {
  display: none;
}
</style>